import React, {useEffect} from "react";
import {  useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import {
  TSDIGITAL_PORTALE_PUBLIC_URL,
  FEATURE_TOGGLE_ASK,
  FEATURE_TOGGLE_TSPAY_ONBOARDING
} from "../../config";
import {getListAsk} from "../../store/actions/ask";

import DashCommercialista from "../../components/dashboard/dashCommercialista";
import DashCliente from "../../components/dashboard/dashCliente";
import Page from "../../components/general/page";
import TsPayOnboardingToast from "../../components/tspay/onboarding/onboardingToast";
import { useIntl } from "react-intl";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const DashboardView = ({ pageRef}) => {
  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const tsPayConfig = useSelector(state => state.tspay.configStatus);

  const studioFind = GetSelectedCompanyStudio();

  const intl = useIntl();

  useEffect(() => {
    if (FEATURE_TOGGLE_ASK === "true") {
      getListAsk(false);
    }
    // Pulisco eventuali variabili tspay inutilizzate in localStorage
    for (let key in localStorage) {
      if (key.indexOf("tspayPaymentUuidToCheck_") > -1) {
        localStorage.removeItem(key);
      }
    }
  }, []);

  const renderTsPayOnboardingToast = () => {
    if (main.myType === "COMPANY"  && isToastToShow && FEATURE_TOGGLE_TSPAY_ONBOARDING === "true") {
      return <TsPayOnboardingToast auth={auth}
        itemId={main.companyUuidSelected}
        onBoardingStatus={onBoardingStatus}
        onBoardingData={onBoardingData}
        isToBeConfirmedStatus={isToBeConfirmedStatus}
      />;
    }
    return undefined;
  };

  let thisCompany = company?.companies?.find(el => {
    return el?.codiceFiscale === main.companySelected;
  });
  let ragioneSociale = thisCompany ? thisCompany.ragioneSociale : null;
  const linkTsVisible = main.myType === "STUDIO" ? TSDIGITAL_PORTALE_PUBLIC_URL + "#/" : null;
  const onBoardingData = tsPayConfig?.data;
  const onBoardingStatus = onBoardingData?.status;
  const isToastToShow = ((onBoardingStatus === "NOT_LINKED") ||
                          (onBoardingStatus === "ONBOARDING") ||
                          (onBoardingStatus === "TO_BE_CONFIRMED" /* && onBoardingData?.onboardingSessions.length !== 0 */)
  );
  const isToBeConfirmedStatus = (onBoardingStatus === "TO_BE_CONFIRMED");

  return (<>
    <Page
      className="contentStructure"
      pageRef={pageRef}      
      title={<FormattedMessage id="dashboard.title" />}
      subtitle={
        main.myType === "STUDIO" ? (
          <FormattedMessage id="dashboard.accountant.subtitle" />
        ) : (
          ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
        )
      }
      backText={studioFind?.taxRegion !== "ES" && <FormattedMessage id="dashboard.goBack" />}
      backUrl={null}
      backLocation={studioFind?.taxRegion !== "ES" && linkTsVisible}
      topHeaderContent={renderTsPayOnboardingToast()}
    >
      {main.myType === "STUDIO" ? (
        <DashCommercialista
          accountantSelected={main.accountantSelected}
          accountantIdSelected={main.accountantIdSelected}
          accountantUuidSelected={main.accountantUuidSelected}
          clientIdSelected={main.clientIdSelected}          
          myType={main.myType}
          companyUuidSelected={main.companyUuidSelected}
        />
      ) : (
        <DashCliente
          companySelected={main.companySelected}
          clientIdSelected={main.clientIdSelected}          
          myType={main.myType}
          currentPermissions={main.currentPermissions}
          accountantSelected={main.accountantSelected}
          accountantIdSelected={main.accountantIdSelected}
          accountantUuidSelected={main.accountantUuidSelected}
          companyUuidSelected={main.companyUuidSelected}
          onBoardingStatus={onBoardingStatus}
          auth={auth}
        />
      )}
    </Page>
  </>);
};

export default DashboardView;
